import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    IconButton,
} from "@mui/material";
import { useLazyGetBookingListQuery } from "../../service/booking";
import { showError } from "../../constants/toasts";
import Loader from "../../constants/Loader";
import CustomPagination from "../../components/CustomPagination";
import dayjs from "dayjs";

const Bookings = () => {
    const navigate = useNavigate();
    const [getBookingList] = useLazyGetBookingListQuery();
    const [searchTerm, setSearchTerm] = useState("");
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
    const [bookings, setBookings] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [count, setCount] = useState(0);

    const getBookingListApi = async () => {
        try {
            setLoading(true);
            const response = await getBookingList({
                page: page,
                limit: 10,
                search: debouncedSearchTerm,
            }).unwrap();
            setLoading(false);
            if (response.statusCode === 200) {
                setBookings(response?.data?.list || []);
                setCount(response?.data?.total || 0);
            } else {
                setBookings([]);
            }
        } catch (error: any) {
            setLoading(false);
            showError(error?.data?.message || "");
        }
    };

    useEffect(() => {
        getBookingListApi();
    }, [page, debouncedSearchTerm]);

    return (
        <>
            <Loader isLoad={loading} />
            <div className="main_title">
                <h1>Booking Management</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Booking Management
                </p>
            </div>

            <div className="cards">
                <div className="table_header">
                    <div className="left_s">
                        <SearchBar
                            value={searchTerm}
                            onChange={(e: any) => setSearchTerm(e.target.value)}
                            onCross={() => {
                                setSearchTerm("");
                                setDebouncedSearchTerm("");
                            }}
                            searchTerm={searchTerm}
                            setDebouncedSearchTerm={setDebouncedSearchTerm}
                            placeholder="Search bookings..."
                        />
                    </div>
                </div>

                <TableContainer className="table_container" sx={{ mt: 3 }}>
                    <Table sx={{ minWidth: 750 }} aria-label="booking table" className="v3">
                        <TableHead>
                            <TableRow hover>
                                <TableCell>Booking ID</TableCell>
                                <TableCell>Service Name</TableCell>
                                <TableCell>Customer Name</TableCell>
                                <TableCell>Date</TableCell>
                                <TableCell>Time</TableCell>
                                <TableCell>Status</TableCell>
                                <TableCell>Action</TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {bookings.length > 0 ? (
                                bookings.map((item, index) => (
                                    <TableRow hover key={item?.id ?? index}>
                                        <TableCell>{item?.bookingId || "-"}</TableCell>
                                        <TableCell>{item?.service?.name || "-"}</TableCell>
                                        <TableCell>{item?.user?.name || "-"}</TableCell>
                                        <TableCell>
                                            {item?.date ? dayjs(item?.date).format("DD MMM YYYY") : "-"}
                                        </TableCell>
                                        <TableCell>{item?.time || "-"}</TableCell>
                                        <TableCell>{item?.status || "-"}</TableCell>
                                        <TableCell>
                                            <Box display="flex" gap={1}>
                                                <IconButton onClick={() => navigate(`/booking/view/${item.id}`)}>
                                                    <img
                                                        src="/static/images/eye_icon.svg"
                                                        alt="View"
                                                        style={{ width: "22px", height: "22px" }}
                                                    />
                                                </IconButton>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={7} align="center">
                                        No bookings found.
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                {bookings?.length ? (
                    <CustomPagination
                        currentPage={page - 1}
                        totalPages={Math.ceil(count / 10)}
                        count={count}
                        pageSize={10}
                        onPageChange={(page) => setPage(page + 1)}
                    />
                ) : null}
            </div>
        </>
    );
};

export default Bookings;
